<template>
    <card body-class="no-padding table-responsive">
        <table class="datatable table table-striped primary dataTable no-footer">
            <thead>
            <tr>
                <th v-for="(col, index) in columns"
                    :class="{'sortable': col.sortable}"
                    v-on:click="onHeaderClick(col)"
                    data-balloon-length="medium"
                    data-balloon-pos="left"
                    :data-balloon="col.tooltip ? $t(col.tooltip) : undefined">
                    <span>{{ $t(col.label) }}</span>
                    <span v-if="orderColumn == col.id">
                        &nbsp;
                        <i v-if="orderFilter.startsWith('-')" class="fa fa-arrow-up" aria-hidden="true"></i>
                        <i v-else class="fa fa-arrow-down" aria-hidden="true"></i>
                    </span>
                    &nbsp;
                    <i class="fa fa-info-circle" v-if="col.tooltip"></i>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in data" :class="calcRowClass(row, index)">
                <template v-for="(col, index) in columns">
                    <td :class="calcCellClass(col, row)">
                        <slot name="default" v-bind:row="row" v-bind:col="col" v-bind:mode="`table`"></slot>
                    </td>
                </template>
            </tr>
            </tbody>
        </table>
        <template v-for="(row, index) in data">
            <card :class="`datalist pb-1 ${calcRowClass(row, index)}`">
                <div :class="`flex-row ${calcCellClass(col, row)}`" v-for="(col, index) in columns">
                    <template v-if="col.label">
                      <div class="col-xs-4">{{ $t(col.label) }}</div>
                      <div class="col-xs-8">
                          <slot name="default" v-bind:row="row" v-bind:col="col" v-bind:mode="`mobile`"></slot>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-xs-12">
                        <slot name="default" v-bind:row="row" v-bind:col="col"></slot>
                      </div>
                    </template>
                </div>
            </card>
        </template>
    </card>
</template>

<script>
  export default {
    name: 'DataTable',
    props: {
      columns: Array,
      data: Array,
      rowClass: Function,
      cellClass: Function,
    },
    data() {
      return {
        orderColumn: null,
        orderFilter: null,
      }
    },
    methods: {
      calcRowClass(row, index) {
        if (typeof this.rowClass === 'function') {
          return this.rowClass(row, index);
        }

        return '';
      },
      calcCellClass(cell, row) {
        if (typeof this.cellClass === 'function') {
          return this.cellClass(cell, row);
        }

        return '';
      },
      onHeaderClick(col) {
        if (col.sortable) {
          const sortkey = typeof col.sortkey === 'string' ? col.sortkey : col.id;

          if (sortkey === this.orderColumn) {
            this.orderFilter = (this.orderFilter.startsWith('-') ?  '' : '-') + this.orderColumn;
          } else {
            this.orderFilter = '-' + sortkey;
          }

          this.orderColumn = sortkey;
          this.$emit('refresh', 0, this.orderFilter);
        }
      },
    }
  }
</script>

<style scoped>
    .datalist {
        display: none;
    }

    th {
      white-space: nowrap;
    }

    @media (max-width: 640px) {
        .datatable {
            display: none;
         }
         .datalist {
             display: initial;
         }
    }
</style>
